import { Badge, type BadgeTone } from '@/components/ui/Badge'
import { Card } from '@/components/ui/Card'
import { Skeleton } from '@/components/ui/Skeleton'

/**
 * 상단 통계 타일 4종 공용 — 오늘 예약(준비 중) · 예약 가능 코트 · 취소 요청 · 이번 달 매출.
 * `isLoading` 이면 값 자리만 스켈레톤으로 대체하고 라벨은 그대로 보여준다(레이아웃 보존).
 */
export function DashboardStatCard({
  label,
  value,
  subText,
  badge,
  isLoading = false,
}: {
  label: string
  value: string
  subText?: string
  badge?: { text: string; tone: BadgeTone } | null
  isLoading?: boolean
}) {
  return (
    <Card className="px-5 py-4">
      <p className="text-sm text-slateish-600">{label}</p>
      {isLoading ? (
        <Skeleton className="mt-2 h-7 w-16" />
      ) : (
        <p className="mt-1 text-2xl font-semibold text-ink-700">{value}</p>
      )}
      {subText || badge ? (
        <div className="mt-1 flex items-center gap-2">
          {subText ? <span className="text-xs text-slateish-600">{subText}</span> : null}
          {badge ? <Badge tone={badge.tone}>{badge.text}</Badge> : null}
        </div>
      ) : null}
    </Card>
  )
}
